/** @format */

import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useState } from 'react';

const pairingHeaders = [
  {
    id: 'pairing_id',
    label: 'ID',
    numeric: false,
    disablePadding: false,
  },
  {
    id: 'pairing_city',
    label: 'City',
    numeric: false,
    disablePadding: false,
  },
  {
    id: 'pairing_duration',
    label: 'Duration',
    numeric: true,
    disablePadding: false,
  },
  {
    id: 'pairing_date',
    label: 'Date',
    numeric: false,
    align: 'center',
    disablePadding: false,
    width: '150px',
  },
  {
    id: 'total_duty_time',
    label: 'Total Duty Time',
    numeric: true,
    disablePadding: false,
  },
  {
    id: 'total_block_time',
    label: 'Total Block Time',
    numeric: true,
    disablePadding: false,
  },
  {
    id: 'total_num_filghts',
    label: 'Total # Flights',
    numeric: true,
    disablePadding: false,
  },
  {
    id: 'total_aircraft_swaps',
    label: 'Total # Aircraft Swaps',
    numeric: true,
    disablePadding: false,
  },
  {
    id: 'max_duty_time',
    label: 'Max Duty Time',
    numeric: true,
    disablePadding: false,
  },
  {
    id: 'max_block_time',
    label: 'Max Block Time',
    numeric: true,
    disablePadding: false,
  },
  {
    id: 'max_num_flights',
    label: 'Max # Flights',
    numeric: true,
    disablePadding: false,
  },
  {
    id: 'max_cost_of_duties',
    label: 'Max Cost of Duties',
    numeric: true,
    disablePadding: false,
  },
  {
    id: 'max_aircraft_swaps',
    label: 'Max # Aircraft Swaps',
    numeric: true,
    disablePadding: false,
  },
  {
    id: 'block/day',
    label: 'Block/Day',
    numeric: true,
    disablePadding: false,
  },
  {
    id: 'num_duties',
    label: '# Duties',
    numeric: true,
    disablePadding: false,
  },
];

const dutyHeaders = [
  {
    id: 'duty_idx',
    label: 'Duty ID',
    numeric: false,
    disablePadding: false,
  },
  {
    id: 'duty_date',
    label: 'Date',
    numeric: false,
    disablePadding: false,
  },
  {
    id: 'duty_time_formatted',
    label: 'Duty Time',
    numeric: false,
    disablePadding: false,
  },
  {
    id: 'block_time_formatted',
    label: 'Block Time',
    numeric: false,
    disablePadding: false,
  },
];
const flightHeaders = [
  {
    id: 'idx',
    label: 'Flight ID',
    numeric: false,
    disablePadding: false,
  },
  {
    id: 'flight_number',
    label: 'Flight Number',
    numeric: false,
    disablePadding: false,
  },
  {
    id: 'aircraft_type',
    label: 'Aircraft Type',
    numeric: false,
    disablePadding: false,
  },
  {
    id: 'departure_station',
    label: 'Origin',
    numeric: false,
    disablePadding: false,
  },
  {
    id: 'arrival_station',
    label: 'Destination',
    numeric: false,
    disablePadding: false,
  },

  {
    id: 'deptime',
    label: 'Flight Departure',
    numeric: false,
    disablePadding: false,
  },
  {
    id: 'arrtime',
    label: 'Flight Arrival',
    numeric: false,
    disablePadding: false,
  },
];

// {
//     duty_idx: 52288,
//     duty_date: '2023-12-31',
//     duty_time: 41100,
//     duty_time_formatted: '11:25',
//     block_time: 24600,
//     block_time_formatted: '6:50',
//     flights: [
//       {
//         flight_number: '103',
//         aircraft_type: 'ER3',
//         departure_station: 'LAS',
//         deptime: '0840',
//         arrival_station: 'BUR',
//         arrtime: '0950',
//         idx: '1032023-12-310840-0800',
//       },

function DutyRow(props) {
  const { row } = props;
  const [flightOpen, setFlightOpen] = useState(false);

  return (
    <>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setFlightOpen(!flightOpen)}
          >
            {flightOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row?.duty_idx}
        </TableCell>
        <TableCell align="left">{row?.duty_date}</TableCell>
        <TableCell align="left">{row?.duty_time_formatted}</TableCell>
        <TableCell align="left">{row?.block_time_formatted}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0 }}
          colSpan={dutyHeaders.length + 1}
        >
          <Collapse in={flightOpen} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                Flight Details
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    {flightHeaders.map((header) => (
                      <TableCell
                        sx={{
                          fontWeight: 'bold',
                        }}
                        key={header.id}
                      >
                        {header.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.flights.map((flight, i) => (
                    <TableRow key={i + flight.idx}>
                      <TableCell>{flight.idx}</TableCell>
                      <TableCell>{flight.flight_number}</TableCell>
                      <TableCell>{flight.aircraft_type}</TableCell>
                      <TableCell>{flight.departure_station}</TableCell>
                      <TableCell>{flight.arrival_station}</TableCell>
                      <TableCell component="th" scope="row">
                        {flight.deptime}
                      </TableCell>
                      <TableCell>{flight.arrtime}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

function PairingRow(props) {
  const { row } = props;
  const [dutyOpen, setDutyOpen] = useState(false);

  return (
    <>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setDutyOpen(!dutyOpen)}
          >
            {dutyOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row?.idx}
        </TableCell>
        <TableCell align="center">{row?.pairing_city}</TableCell>
        <TableCell align="center">{row?.pairing_duration}</TableCell>
        <TableCell align="center">{row?.pairing_date}</TableCell>
        <TableCell align="center">{row?.total_duty_time}</TableCell>
        <TableCell align="center">{row?.total_block_time}</TableCell>
        <TableCell align="center">{row?.total_num_flights}</TableCell>
        <TableCell align="center">{row?.total_aircraft_swaps}</TableCell>
        <TableCell align="center">{row?.max_duty_time}</TableCell>
        <TableCell align="center">{row?.max_block_time}</TableCell>
        <TableCell align="center">{row?.max_num_flights}</TableCell>
        <TableCell align="center">{row?.max_cost_of_duties}</TableCell>
        <TableCell align="center">{row?.max_aircraft_swaps}</TableCell>
        <TableCell align="center">{row['block/day']}</TableCell>
        <TableCell align="center">{row?.num_duties}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0 }}
          colSpan={pairingHeaders.length + 1}
        >
          <Collapse in={dutyOpen} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                Duty Details
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell />
                    {dutyHeaders.map((header) => (
                      <TableCell
                        sx={{
                          fontWeight: 'bold',
                        }}
                        key={header.id}
                      >
                        {header.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.duties.map((duty, i) => {
                    console.log(duty);
                    return <DutyRow key={duty.duty_idx + i} row={duty} />;
                  })}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

DutyRow.propTypes = {
  row: PropTypes.shape({
    duty_idx: PropTypes.number.isRequired,
    duty_date: PropTypes.string.isRequired,
    duty_time: PropTypes.number.isRequired,
    block_time: PropTypes.number.isRequired,
    duty_time_formatted: PropTypes.string.isRequired,
    block_time_formatted: PropTypes.string.isRequired,
    flights: PropTypes.arrayOf(
      PropTypes.shape({
        flight_number: PropTypes.string.isRequired,
        aircraft_type: PropTypes.string.isRequired,
        departure_station: PropTypes.string.isRequired,
        arrival_station: PropTypes.string.isRequired,
        deptime: PropTypes.string.isRequired,
        arrtime: PropTypes.string.isRequired,
        idx: PropTypes.string.isRequired,
      })
    ).isRequired,
  }).isRequired,
};

PairingRow.propTypes = {
  row: PropTypes.shape({
    idx: PropTypes.number.isRequired,
    pairing_city: PropTypes.string.isRequired,
    pairing_duration: PropTypes.number.isRequired,
    pairing_duration_formatted: PropTypes.string.isRequired,
    layover_city: PropTypes.string,
    layover_time: PropTypes.number,
    layover_time_formatted: PropTypes.string,
    total_duty_time: PropTypes.number.isRequired,
    total_block_time: PropTypes.number.isRequired,
    total_num_flights: PropTypes.number.isRequired,
    total_cost_of_duties: PropTypes.number.isRequired,
    total_aircraft_swaps: PropTypes.number.isRequired,
    max_duty_time: PropTypes.number.isRequired,
    max_block_time: PropTypes.number.isRequired,
    max_num_flights: PropTypes.number.isRequired,
    max_cost_of_duties: PropTypes.number.isRequired,
    max_aircraft_swaps: PropTypes.number.isRequired,
    'block/day': PropTypes.number.isRequired,
    num_duties: PropTypes.number.isRequired,
    duties: PropTypes.arrayOf(
      PropTypes.shape({
        duty_idx: PropTypes.number.isRequired,
        duty_date: PropTypes.string.isRequired,
        duty_time: PropTypes.number.isRequired,
        block_time: PropTypes.number.isRequired,
        duty_time_formatted: PropTypes.string.isRequired,
        block_time_formatted: PropTypes.string.isRequired,
        flights: PropTypes.arrayOf(
          PropTypes.shape({
            flight_number: PropTypes.string.isRequired,
            aircraft_type: PropTypes.string.isRequired,
            departure_station: PropTypes.string.isRequired,
            arrival_station: PropTypes.string.isRequired,
            deptime: PropTypes.string.isRequired,
            arrtime: PropTypes.string.isRequired,
            idx: PropTypes.string.isRequired,
          })
        ).isRequired,
      })
    ).isRequired,
  }).isRequired,
};

export default function PairingModelDetailsDutyTable({ pairings }) {
  return (
    <TableContainer component={Paper}>
      <Typography variant="h6" gutterBottom component="div">
        Selected Pairing Details
      </Typography>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <TableCell />
            {pairingHeaders.map((header) => (
              <TableCell
                sx={{
                  fontWeight: 'bold',
                }}
                key={header.id}
                align="center"
              >
                {header.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {pairings?.map((row, i) => (
            <PairingRow key={row.idx + i} row={row} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
